<template>
  <div @click="model = true">
    <v-badge
      overlap
      v-if="showFilters"
      icon
      :color="
        _isCordovaApp() || $vuetify.breakpoint.xsOnly
          ? 'white primary--text'
          : 'primary white--text'
      "
      class="ma-0 pa-0"
      :content="filtersSum"
      :value="filtersSum"
    >
      <v-icon
        :color="
          _isCordovaApp() || $vuetify.breakpoint.xsOnly ? 'white' : 'primary'
        "
        >{{ mdiFilterOutline }}</v-icon
      >
    </v-badge>

    <v-dialog
      v-model="model"
      transition="dialog-bottom-transition"
      v-bind:content-class="dialogClasses"
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      scrollable
    >
      <v-card class="text-center ma-0 pa-0" v-bind:class="dialogHeight">
        <v-card-title class="ma-0 pa-0">
          <vetalfa-small-header
            :backMethod="
              () => {
                model = false;
              }
            "
            class="vetalfa-padding-top-notch vetalfa-max-width"
            :title="filterLabels.FILTERS"
            closable
            isNavigationDialog
          ></vetalfa-small-header>
          <v-divider></v-divider>
          <v-row class="ma-0 pa-0" style="width: 100%">
            <v-tabs
              v-model="tabModel"
              background-color="transparent"
              color="#193153 !important"
              centered
              height="50px"
              class="mt-2"
              v-if="filteredTabs.length && filteredTabs.length > 1"
              fixed-tabs
            >
              <v-tab
                class="text-capitalize"
                v-for="(tab, index) in filteredTabs"
                :key="tab.name"
                @click="
                  $vuetify.goTo(0, {
                    duration: 0,
                    offset: 0,
                    easing: 'easeInOutCubic',
                  })
                "
              >
                <v-badge
                  dot
                  bordered
                  color="primary"
                  :content="
                    (index == 0 && basicFiltersCount) ||
                    (index == 1 && categoriesFilterCount) ||
                    (index == 2 && activePrinciplesFilterCount) ||
                    (index == 2 && brandsFiltersCount)
                  "
                  :value="
                    (index == 0 && basicFiltersCount) ||
                    (index == 1 && categoriesFilterCount) ||
                    (index == 2 && activePrinciplesFilterCount) ||
                    (index == 2 && brandsFiltersCount)
                  "
                >
                  <span class="px-2 vetalfa-tab-text vetalfa-text-overflow">{{
                    tab.name
                  }}</span>
                </v-badge>
              </v-tab>
            </v-tabs>
          </v-row>
        </v-card-title>
        <v-divider
          v-if="filteredTabs.length && filteredTabs.length > 1"
        ></v-divider>
        <v-card-text id="filter-tabs-items" class="ma-0 pa-0">
          <v-tabs-items
            v-model="tabModel"
            class="ma-0 pa-0"
            style="width: 100%"
          >
            <v-tab-item v-if="isPhotosCategory" v-show="tabModel == 0">
              <vetalfa-section-title :prop="filterLabels.ALLOWED_ANIMALS">
                <animal-selector
                  :clearTrigger="clearTrigger"
                  v-on:selectAnimal="selectAnimal"
                  plural
                  hasBothAnimals
                  :defaultValue="animalsFilter"
                >
                </animal-selector>
              </vetalfa-section-title>
              <vetalfa-section-title :prop="filterLabels.PRESENTATIONS">
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectPresentation"
                  :items="presentationList"
                  :defaultValue="presentationFilter"
                ></chip-group>
              </vetalfa-section-title>
              <vetalfa-section-title
                v-if="$route.params.topic == 'supplements'"
                :prop="filterLabels.BRANDS"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectBrand"
                  :items="brandList"
                  multiple
                  :defaultValue="defaultBrandsFilter"
                ></chip-group>
              </vetalfa-section-title>

              <vetalfa-section-title
                v-if="$route.params.topic != 'supplements'"
                :prop="filterLabels.PET_SIZE"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectPetSizes"
                  :items="petSizes"
                  multiple
                  :defaultValue="defaultPetSizesFilter"
                ></chip-group>
              </vetalfa-section-title>

              <vetalfa-section-title
                v-if="$route.params.topic !== 'supplements'"
                :prop="filterLabels.PET_AGE"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectPetAges"
                  :items="petAges"
                  multiple
                  :defaultValue="defaultPetAgesFilter"
                ></chip-group>
              </vetalfa-section-title>

              <vetalfa-section-title
                v-if="
                  $route.params.topic != 'supplements' && petBreeds.length
                "
                :prop="filterLabels.PET_BREED"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectPetBreeds"
                  :items="petBreeds"
                  multiple
                  :defaultValue="defaultPetBreedsFilter"
                ></chip-group>
              </vetalfa-section-title>
            </v-tab-item>

            <v-tab-item
              v-if="category.id != 1"
              v-show="tabModel == 1 || $route.params.topic != 'supplements'"
            >
              <vetalfa-section-title
                v-if="!!$route.params.topic"
                :prop="filterLabels.ALLOWED_ANIMALS"
              >
                <animal-selector
                  :clearTrigger="clearTrigger"
                  v-on:selectAnimal="selectAnimal"
                  plural
                  hasBothAnimals
                  :defaultValue="animalsFilter"
                >
                </animal-selector>
              </vetalfa-section-title>
              <vetalfa-section-title :prop="filterLabels.CATEGORIES">
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="setClass"
                  :items="classesList"
                  :defaultValue="classesFilter"
                ></chip-group>
              </vetalfa-section-title>
              <vetalfa-section-title
                v-if="category.foods"
                :prop="filterLabels.FEATURES"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="setFeature"
                  :items="features"
                  :defaultValue="featuresFilter"
                  multiple
                ></chip-group>
              </vetalfa-section-title>
            </v-tab-item>

            <v-tab-item
              v-if="$route.params.topic == 'supplements'"
              v-show="tabModel == 2"
            >
              <vetalfa-section-title :prop="filterLabels.ACTIVE_PRINCIPLES">
                <v-autocomplete
                  v-model="activePrinciplesModel"
                  :items="activePrinciplesList"
                  :label="activePrinciplesLabel"
                  :menu-props="{ maxHeight: 154 }"
                  class="pa-2"
                  multiple
                  :no-data-text="labels.DRUGS_NO_DATA"
                  item-color="primary"
                  clearable
                  outlined
                  :filter="customFilter"
                  :dense="activePrinciplesModel.length == 0"
                >
                  <template v-slot:selection="{ item, parent }">
                    <v-chip color="primary" filter label>
                      {{ item }}
                      <v-icon
                        small
                        class="ml-2"
                        @click="parent.selectItem(item)"
                      >
                        {{ mdiClose }}
                      </v-icon>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </vetalfa-section-title>
            </v-tab-item>

            <v-tab-item
              v-if="$route.params.topic != 'supplements' && tabModel == 2"
            >
              <vetalfa-section-title :prop="filterLabels.BRANDS">
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectSingleBrand"
                  :items="brandList"
                  :defaultValue="defaultSingleBrand"
                ></chip-group>
              </vetalfa-section-title>
              <vetalfa-section-title
                v-if="lines.length"
                :prop="filterLabels.BRANDS_LINES"
              >
                <chip-group
                  :clearTrigger="clearTrigger"
                  v-on:selectChip="selectBrandLine"
                  :items="lines"
                  :defaultValue="brandLinesFilter"
                ></chip-group>
              </vetalfa-section-title>
            </v-tab-item>
          </v-tabs-items>
          <v-row
            class="ma-0 pa-0 white"
            style="height: 50px !important"
          ></v-row>
        </v-card-text>
        <v-card-actions class="vetalfa-margin-bottom-notch py-4 px-2">
          <v-row class="ma-0 pa-0 white">
            <v-col
              class="ma-0 pa-0 pr-1"
              :cols="$vuetify.breakpoint.xsOnly ? 6 : 4"
            >
              <v-btn
                outlined
                @click="clearAll()"
                block
                class="text-none primary--text"
                v-show="hasFilters"
              >
                {{ filterLabels.CLEAR_ALL }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              class="ma-0 pa-0 pl-1"
              :cols="$vuetify.breakpoint.xsOnly ? 6 : 4"
            >
              <v-btn @click="model = false" block class="text-none primary">
                {{ filterLabels.SEE_RESULTS }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
.items-filter-mobile-height {
  height: 600px;
}
.items-filter-height {
  height: 500px;
}
</style>

<script>
import labels from "@/constants/labels.js";
import { mapGetters, mapMutations, mapActions } from "vuex";
import AnimalSelector from "@/components/AnimalSelector.vue";
import ChipGroup from "@/components/ChipGroup.vue";
import { mdiFilterOutline, mdiClose } from "@mdi/js";
const filterLabels = {
  ALLOWED_ANIMALS: "Aplicações permitidas em:",
  BRANDS_LINES: "Linhas",
  PRESENTATIONS: "Apresentações:",
  CATEGORIES: "Categorias",
  BRANDS: "Marcas",
  ACTIVE_PRINCIPLES: "Princípios Ativos",
  FILTERS: "Filtros",
  RESULTS: "resultados",
  CLEAR_FILTERS: "Limpar filtros",
  ACTIVE_PRINCIPLES_LABEL: "Busque e adicione um ou mais princípios ativos:",
  SEE_RESULTS: "Ver resultados",
  CLEAR_ALL: "Limpar tudo",
  DRUGS_CLASSES: "Classes para",
  DRUGS_CLASSES_SELECTION: "Seleção de classes",
  PET_SIZE: "Porte do Paciente",
  PET_AGE: "Idade",
  PET_BREED: "Raça",
  FEATURES: "Características",
};
const tabs = [
  { name: "Básicos", categories: [10, 9, 8, 6] },
  { name: "Categorias", categories: [6, 2, 3, 4, 5, 8, 10, 9] },
  { name: "Princípios Ativos", categories: [6] },
  { name: "Sistemas", categories: [1] },
  { name: "Classes", categories: [1] },
  { name: "Marcas", categories: [8, 10, 9] },
];
export default {
  components: {
    "animal-selector": AnimalSelector,
    "chip-group": ChipGroup,
  },
  props: {
    showFilters: { type: Boolean, required: true, default: false },
  },
  computed: {
    ...mapGetters("drugs", [
      "brandLines",
      "brandLinesFilter",
      "itemsList",
      "dogFilter",
      "catFilter",
      "presentationList",
      "presentationFilter",
      "classesList",
      "classesFilter",
      "brandList",
      "brandFilter",
      "activePrinciplesList",
      "activePrinciplesFilter",
      "category",
      "petAges",
      "petSizes",
      "petBreeds",
      "petAgesFilter",
      "petSizesFilter",
      "petBreedsFilter",
      "featuresFilter",
      "features",
      "categoryFilter",
    ]),

    isPhotosCategory() {
      return !!this.category && this.category.orderByPhotos;
    },

    defaultSingleBrand() {
      let obj = undefined;
      this.brandList.forEach((value, index) => {
        if (this.brandFilter.includes(value)) {
          obj = index;
        }
      });
      return obj;
    },

    activePrinciplesLabel() {
      return this.activePrinciplesModel.length == 0
        ? this.filterLabels.ACTIVE_PRINCIPLES_LABEL
        : "";
    },
    lines() {
      let arr = [];
      if (this.brandFilter.length) {
        this.setBrandLinesFilter(undefined);
        arr = this.brandLines[this.brandFilter[0]];
      }
      arr = [...new Set(arr)].sort();
      this.setLines(arr);
      return arr;
    },
    animalsFilter() {
      return this.dogFilter
        ? this.catFilter
          ? 2
          : 0
        : this.catFilter
        ? 1
        : null;
    },
    defaultBrandsFilter() {
      let arr = [];
      this.brandList.forEach((value, index) => {
        if (this.brandFilter.includes(value)) {
          arr.push(index);
        }
      });
      return arr;
    },
    defaultPetAgesFilter() {
      let arr = [];
      this.petAges.forEach((value, index) => {
        if (this.petAgesFilter.includes(value)) {
          arr.push(index);
        }
      });
      return arr;
    },
    defaultPetSizesFilter() {
      let arr = [];
      this.petSizes.forEach((value, index) => {
        if (this.petSizesFilter.includes(value)) {
          arr.push(index);
        }
      });
      return arr;
    },
    defaultPetBreedsFilter() {
      let arr = [];
      this.petBreeds.forEach((value, index) => {
        if (this.petBreedsFilter.includes(value)) {
          arr.push(index);
        }
      });
      return arr;
    },
    dialogHeight() {
      return this.$vuetify.breakpoint.xsOnly
        ? "items-filter-mobile-height"
        : "items-filter-height";
    },
    dialogClasses() {
      return this.$vuetify.breakpoint.xsOnly ? "v-bottom-sheet" : "";
    },
    hasFilters() {
      const hasFilter =
        this.dogFilter ||
        this.catFilter ||
        this.presentationFilter !== undefined ||
        this.brandFilter.length ||
        this.classesFilter !== undefined ||
        this.activePrinciplesFilter.length ||
        this.petAgesFilter.length ||
        this.petSizesFilter.length ||
        this.petBreedsFilter.length ||
        this.featuresFilter.length;
      this.setHasFilter(hasFilter);
      return hasFilter;
    },
    activePrinciplesModel: {
      get() {
        return this.activePrinciplesFilter;
      },
      set(val) {
        this.setActivePrinciplesFilter(val);
        this.applyFilters();
      },
    },
    itemsCount() {
      return this.itemsList.filter((i) => {
        return !!i.name;
      }).length;
    },
    brandsFiltersCount() {
      let num =
        this.brandFilter.length > 0 &&
        this.$route.params.topic != "supplements"
          ? 1
          : 0;
      num += this.brandLinesFilter !== undefined ? 1 : 0;
      return num;
    },
    basicFiltersCount() {
      let num = this.dogFilter || this.catFilter ? 1 : 0;
      num += this.presentationFilter !== undefined ? 1 : 0;
      num +=
        this.brandFilter.length > 0 &&
        this.$route.params.topic == "supplements"
          ? 1
          : 0;
      num += this.petAgesFilter.length ? 1 : 0;
      num += this.petSizesFilter.length ? 1 : 0;
      num += this.petBreedsFilter.length ? 1 : 0;
      return num;
    },
    categoriesFilterCount() {
      return (
        (this.classesFilter !== undefined && this.classesFilter !== null
          ? 1
          : 0) + (this.featuresFilter.length ? 1 : 0)
      );
    },
    activePrinciplesFilterCount() {
      return this.activePrinciplesFilter.length > 0 ? 1 : 0;
    },
    filtersSum() {
      return (
        this.basicFiltersCount +
        this.categoriesFilterCount +
        this.activePrinciplesFilterCount +
        this.brandsFiltersCount
      );
    },
    filteredTabs() {
      let arr = [];
      tabs.forEach((t) => {
        if (
          t.categories.includes(
            this.$route.params.topic == "supplements" ? 6 : this.category.id
          ) ||
          t.categories.includes(this.categoryFilter)
        ) {
          arr.push(t);
        }
      });
      return arr;
    },
  },
  methods: {
    ...mapMutations("drugs", [
      "setHasFilter",
      "setItemsList",
      "setDogFilter",
      "setCatFilter",
      "setPresentationFilter",
      "setClassesFilter",
      "setBrandFilter",
      "setActivePrinciplesList",
      "setActivePrinciplesModelList",
      "setActivePrinciplesFilter",
      "setVirtualScroll",
      "setPetAgesFilter",
      "setPetSizesFilter",
      "setPetBreedsFilter",
      "setFeaturesFilter",
      "setBrandLinesFilter",
      "setLines",
    ]),
    ...mapMutations("general", ["setLoadingOn", "setLoadingOff"]),
    ...mapActions("general", ["openExternalUrl", "logEvent"]),
    ...mapActions("drugs", ["clearFilters"]),
    manageScrollProblems() {
      let vCardText = document.getElementById("filter-tabs-items");
      if (vCardText) {
        vCardText.addEventListener("scroll", function () {
          let el = document.getElementById("filter-tabs-items");
          if (el.scrollHeight - el.clientHeight - 1 < el.scrollTop) {
            el.scrollTop = el.scrollHeight - el.clientHeight - 1;
          }
        });
      } else {
        setTimeout(
          function () {
            this.manageScrollProblems();
          }.bind(this),
          100
        );
      }
    },
    customFilter(item, queryText, itemText) {
      itemText = this._createIdentifier(itemText);
      queryText = this._createIdentifier(queryText);
      return itemText.includes(queryText);
    },
    selectBrandLine(val) {
      this.setBrandLinesFilter(val);
      this.applyFilters();
    },
    applyFilters() {
      this.$emit("applyFilters", this.hasFilters);
    },
    clearAll() {
      this.clearFilters();
      this.clearTrigger = new Date();
      setTimeout(
        function () {
          this.clearFilters();
          this.$emit("applyFilters", this.hasFilters);
        }.bind(this),
        1
      );
    },
    selectAnimal(obj) {
      switch (obj.value) {
        case 0:
          this.setCatFilter(false);
          this.setDogFilter(true);
          break;
        case 1:
          this.setCatFilter(true);
          this.setDogFilter(false);
          break;
        case 2:
          this.setCatFilter(true);
          this.setDogFilter(true);
          break;
        default:
          this.setCatFilter(false);
          this.setDogFilter(false);
          break;
      }
      this.applyFilters();
    },
    selectBrand(val) {
      let arr = [];
      val.forEach((v) => {
        arr.push(this.brandList[v]);
      });
      this.setBrandFilter(arr);
      this.applyFilters();
    },
    selectSingleBrand(val) {
      this.setBrandFilter(val === undefined ? [] : [this.brandList[val]]);
      this.applyFilters();
    },

    selectPetAges(val) {
      let arr = [];
      val.forEach((v) => {
        arr.push(this.petAges[v]);
      });
      this.setPetAgesFilter(arr);
      this.applyFilters();
    },

    selectPetSizes(val) {
      let arr = [];
      val.forEach((v) => {
        arr.push(this.petSizes[v]);
      });
      this.setPetSizesFilter(arr);
      this.applyFilters();
    },

    selectPetBreeds(val) {
      let arr = [];
      val.forEach((v) => {
        arr.push(this.petBreeds[v]);
      });
      this.setPetBreedsFilter(arr);
      this.applyFilters();
    },
    selectPresentation(val) {
      this.setPresentationFilter(val);
      this.applyFilters();
    },
    setClass(val) {
      this.setClassesFilter(val);
      this.applyFilters();
    },
    setFeature(val) {
      let arr = [];
      val.forEach((v) => {
        arr.push(this.features[v]);
      });
      this.setFeaturesFilter(arr);
      this.applyFilters();
    },
    manageVirtualScroll() {
      let el = document.getElementById("drugs-virtual-scroll");
      if (el == null) {
        setTimeout(this.manageVirtualScroll, 10);
        return;
      }
      this.setVirtualScroll(0);
      el.scrollTop = 0;
    },
  },
  watch: {
    brandFilter() {
      this.setBrandLinesFilter(undefined);
      this.applyFilters();
    },
    model(val) {
      if (val) {
        this.logEvent(this.category.openSectionMethod + "Filter");
      } else if (!val && this.hasFilters) {
        this.setLoadingOn();
        setTimeout(
          function () {
            this.manageVirtualScroll();
            this.setLoadingOff();
          }.bind(this),
          100
        );
      }
    },
  },
  data() {
    return {
      model: false,
      labels,
      tabs,
      tabModel: 0,
      filterLabels,
      mdiFilterOutline,
      mdiClose,
      clearTrigger: 0,
      drugsClasses: [],
      enabledDrugsClassesFilter: true,
    };
  },
  mounted() {
    this.manageScrollProblems();
  },
  created() {},
};
</script>